<template>
    <div class="main">

        <!--<nav aria-label="breadcrumb">-->
            <!--<ol class="breadcrumb">-->
                <!--<li class="breadcrumb-item"><a :href="'/gmView/' + geneLocus">{{geneLocus}}</a></li>-->
                <!--<li class="breadcrumb-item active" aria-current="page">{{rnaName}}</li>-->
            <!--</ol>-->
        <!--</nav>-->

        <h2 class="round">Germline Morphology Result</h2>

        <div class="mainContent">
            <div class="row">
                <div class="col-sm-6">
                    <fetch-broad-pheno-genes :class-id="classId">
                        <template slot-scope="{response, loading}">
                            <div v-if="loading">Loading...</div>
                            <div v-else-if="response.length > 0">

                                <h4 class="round">Broad Phenotypic Related Genes</h4>
                                <div class="panel panel-default">
                                    <div class="panel-heading">
                                        <table class="pheno table table-striped table-hover table-responsive">
                                            <thead>
                                            <tr class="active">
                                                <th>Gene</th>
                                            </tr>
                                            </thead>
                                            <tbody>
                                            <tr v-for="(item, idx) in response" v-bind:key="'b-' + idx">
                                                <th>
                                                    <a :href="'/gmView/' + item.geneName" v-show="item.locusName === ''">{{item.geneName}}</a>
                                                    <a :href="'/gmView/' + item.locusName" v-show="item.locusName !== ''">{{item.geneName}} ({{item.locusName}})</a>
                                                </th>
                                            </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </template>
                    </fetch-broad-pheno-genes>
                </div>
                <div class="col-sm-6">
                    <fetch-pheno-genes :pheno-id="phenoId">
                        <template slot-scope="{response, loading}">
                            <div v-if="loading">Loading...</div>
                            <div v-else-if="response.length > 0">

                                <h4 class="round">Phenotypic Related Genes</h4>
                                <div class="panel panel-default">
                                    <div class="panel-heading">
                                        <table class="pheno table table-striped table-hover table-responsive">
                                            <thead>
                                            <tr class="active">
                                                <th>Gene</th>
                                            </tr>
                                            </thead>
                                            <tbody>
                                            <tr v-for="(item, idx) in response" v-bind:key="'p-' + idx">
                                                <th>
                                                    <a :href="'/gmView/' + item.geneName" v-show="item.locusName === ''">{{item.geneName}}</a>
                                                    <a :href="'/gmView/' + item.locusName" v-show="item.locusName !== ''">{{item.geneName}} ({{item.locusName}})</a>
                                                </th>
                                            </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </template>
                    </fetch-pheno-genes>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
  import FetchBroadPhenoGenes from './FetchBroadPhenoGenes'
  import FetchPhenoGenes from './FetchPhenoGenes'

  const _ = require('lodash');

  export default {
    name: "ResultView",
    components: {
      FetchBroadPhenoGenes, FetchPhenoGenes
    },
    data() {
      return {
        classId: this.$route.params.classId,
        phenoId: this.$route.params.phenoId,
        publicPath: process.env.BASE_URL
      }
    },
    methods: {
    },
    mounted() {
      // const vm = this
      // vm.images = []
      // /* eslint-disable no-console */
      // console.log(vm.dsRnaName);
    },
  }
</script>

<style>
    @import url('~@/assets/bootstrap.css');
    @import url('~@/assets/datatable.css');

    .important {
        border: 1px solid #aaaaaa;
        padding: 0.3em;
        margin-bottom: 1em;
        background-color: #EEB8B4;
    }

    li {
        padding-left: 10px;
    }

    .main {
        margin: 1.5rem;
    }

    .clear {
        background-color: #c7eedc;
    }

    .ambiguous {
        background-color: #b1aeb4;
    }

    .severe {
        background-color: #ee9c97;
    }

    .playing {
        background-color: lightgreen;
    }

    .container {
        position: relative;
        text-align: center;
        color: white;
    }

    .body {
        font-weight: bold;
        font-size: 12px;
    }

    .breadcrumb {
        font-size: 1.3rem;
    }

    .breadcrumb a {
        display: inline;
        padding: 0 0.5em;
    }

    .row {
        font-size: 1.2rem;
        padding-bottom: 8px;
    }

    .centered {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        font-weight: bold;
        font-size: 20px;
        text-decoration: underline;
    }

    .blue {
        color: #2834ff;
    }

    .white {
        color: white;
    }

    .round {
        font-family: Calibri, Candara, Segoe, Segoe UI, Optima, Arial;
        border-radius: 7px;
        border: 1px solid #d9d9d9;
        background: #dae3f3;
        padding: 3px 7px 3px 7px;
        font-style: oblique;
        color: #203864;
        font-weight: bold;
    }

    .text {
        font-weight: bold;
        color: #203864;
        padding-bottom: 10px;
    }

    p.strong {
        text-decoration: underline;
        font-style: oblique;
    }

    h2.card-title {
        margin-top: 0;
        color: #2f5597;
        font-style: oblique;
    }

    h5.card-title {
        color: #2f5597;
        font-style: oblique;
        font-weight: bold;
    }

    .mainContent {
        border-radius: 25px;
        border: 2px solid #dae3f3;
        padding: 20px;
    }
</style>